import {STATE, USERSTATES} from "../classes/Enum";
import '../styles/footer.css';

function FooterComponent({cart, setState, user, setUserState}) {

    const goToTop = () => {
        window.scrollTo({
            top: 5000,
            behavior: 'smooth',
        });
    };

    function getCartCount() {
        return cart.reduce((total, item) => total + item.count, 0);
    }

    return (<div id="footer">
        <button className="footer-button" onClick={() => setState(STATE.OVERVIEW)}>
            <h2>All</h2>
            <img src='\assets\svgs\home.svg' alt="home"></img>
        </button>
        <button className="footer-button" onClick={() => setState(STATE.SEALED)}>
            <h2>Sealed</h2>
            <img src="\assets\imgs\sealed.png" alt="sealed"></img>
        </button>
        <button className="footer-button" onClick={() => setState(STATE.PACK)}>
            <h2>Packs</h2>
            <img src="\assets\imgs\packs.png" alt="packs"></img>
        </button>
        <button className="footer-button" onClick={() => {setState(STATE.PROFILE); setUserState(USERSTATES.SIGN)}}>
            <h3>{user === null ? 'Sign in' : user}</h3>
            <img src="\logo192.png" alt="Login/Register"></img>
        </button>
        <button className="footer-button" onClick={() => setState(STATE.SINGLE)}>
            <h2>Singles</h2>
            <img src="\assets\imgs\single.png" alt="cart"></img>
        </button>
        <button className="footer-button" onClick={() => setState(STATE.PROMO)}>
            <h2>Promo</h2>
            <img src="\assets\imgs\promotion.png" alt="cart"></img>
        </button>
        <button className="footer-button" onClick={() => setState(STATE.CART)}>
            <h2>Cart ({getCartCount()})</h2>
            <img src={getCartCount() > 0 ? "/assets/imgs/shopping-cart-filled.png" : "/assets/imgs/shopping-cart.png"} alt="cart"></img>
        </button>

        </div>)
}

export default FooterComponent